import { Component, OnInit, NgZone } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ScannerService } from './service/scanner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterModule, MatSnackBarModule]
})
export class AppComponent implements OnInit {
  constructor(
    private scannerService: ScannerService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    // 监听全局扫描（由ScannerService负责注册window事件）
    this.scannerService.onScan$.subscribe((barcode: string) => {
      this.handleScan(barcode);
    });
  }

  private handleScan(barcode: string): void {
    if (!barcode) return;
    console.log('AppComponent Scanned:', barcode);
  }
}